import React from 'react';
import { Snackbar, Alert, Typography } from '@mui/material';

interface NotificationSnackbarProps {
  open: boolean;
  message: string;
  severity: 'success' | 'error' | 'info' | 'warning';
  onClose: () => void;
  autoHideDuration?: number;
}

/**
 * A notification component that displays messages with different severity levels
 * Used throughout the TicketEasy module
 */
export function NotificationSnackbar({ 
  open, 
  message, 
  severity, 
  onClose, 
  autoHideDuration = 6000 
}: NotificationSnackbarProps) {
  
  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    onClose();
  };

  if (!open) {
    return null;
  }
  
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ minWidth: '300px' }}
    >
      <Alert 
        onClose={handleClose} 
        severity={severity} 
        elevation={6} 
        variant="standard"
        sx={{ 
          width: '100%', 
          minWidth: '300px',
          '& .MuiAlert-message': {
            display: 'flex',
            alignItems: 'center'
          }
        }}
      >
        <Typography variant="body2">{message}</Typography>
      </Alert>
    </Snackbar>
  );
}
